<template>
  <div class="tag" v-if="tagWords && tagWords.length > 0 ">
    <strong class="cxStrong"><a :href="tags.pub_url" target="_blank" @click="countAd(4533)">#<em>{{tags.word}}</em>#</a></strong>
    <div class="carsBox">
      <ul class="tab-list">
        <li v-for="(tag,index) in tagWords" :key="index">
          <a :title="tag.title" :href="tag.pub_url" target="_blank" class="pic-txt"  @click="countAd(4534)">
            <img :src="tag.guide_pic_url2 || $indexTagDefaultImaUrl" />
            <p>{{tag.title}}</p>
          </a>
          <div class="infor">
            <span href="javascript:void(0)" target="_blank" class="name">
              {{tag.author || tag.inputuserid}}
            </span>
            <a :href="tag.pub_url+'#Jcmtcontent'" class="count" target="_blank"  @click="countAd(4535)">{{tag.cnt_num}}</a>
          </div>
        </li>
      </ul>
      <div class="other">
        <a target="_blank" href="//www.pcauto.com.cn/tag/sy/?ad=4420"  @click="countAd(4536)">查看全部文章标签&gt;&gt;</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'IndexTag',
    props: {
        tagWordArticle: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            tagWords: [], //标签内容
            tags: '', //便签名字概括数据
        }
    },
    watch: {
        tagWordArticle(n) {
            this.tagWords = n.items
            this.tags = n.tagWord
        }
    }
};
</script>

<style lang="scss" scoped>
.tag {
    margin-bottom: 25px;
    .cxStrong {
        font-weight: normal;
        font-size: 16px;
        line-height: 36px;
        display: inline-block;
        a {
            text-decoration: underline;
            color: #225599;   
            em {
                color: #cc0000;
                text-decoration: underline;                
                font-style: normal;
            }         
        }
    }   
    .carsBox  {
        border: 1px solid #e5e5e5;
        .tab-list {
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            li {
                width: 185px;
                display: inline;
                overflow: hidden;
                margin: 10px 10px 10px 10px;                
                a {
                    color: #000;
                    text-decoration: none;
                    outline: none;   
                    img {
                        width: 185px; 
                        border: 0;
                        vertical-align: middle;
                    }
                    p {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        height: 42px;                        
                    }                 
                }
            }
            .infor {
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .name {
                    line-height: 20px;
                    margin-top: 8px;
                    padding-left: 20px;
                    color: #777;           
                    display: inline;
                    background-image: url(//ueimg.3conline.com/pcauto/pc/art/w/wenzhang/1.0.0/images/icon5.png);
                    background-repeat: no-repeat;
                    -webkit-background-size: 14px 14px;
                    background-size: 14px 14px;
                    background-position: left center;         
                }
                .count {
                    display: inline;
                    background-image: url(//ueimg.3conline.com/pcauto/pc/art/w/wenzhang/1.0.0/images/icon3.png);
                    background-repeat: no-repeat;
                    background-position: left 4px;
                    -webkit-background-size: 14px 13px;
                    background-size: 14px 13px;
                    line-height: 20px;
                    margin-top: 8px;
                    padding-left: 20px;
                    color: #777;
                }
            }
        }
    }
    .other {
        text-align: center;
        height: 30px;
        line-height: 30px;
        margin-top: 5px;
        background-color: #F2F2F2;       
        a {
            color: #989898;
        } 
    }
}
</style>
